import { store } from '@/store/configuration';

export const createHttpHeader = (contentType: string = 'application/json') => {
  const state = store.getState();

  const accessToken = state.auth.token?.access_token;

  if (!accessToken) throw new Error('Access Token not found');

  return {
    Accept: contentType,
    'Content-Type': contentType,
    Authorization: `Bearer ${accessToken}`,
  };
};
